import ChartsPageAdmin from './ChartsPageAdmin';

export default ChartsPageAdmin;
